export const REGION_TAG_TYPE = 'Region' as const;
